<template>
  <div class="zj-header">
    <div class="zj-app-logo zj-app-logo_bghqf" @click="toCommonLogin" v-if="project=='hongqifang'"></div>
    <div class="zj-app-logo" @click="toCommonLogin" v-else>{{title}}</div>

    <zj-nav-menu :height="height" />
    <zj-action-panel :height="height" />
    <div class="zj-header-bg">
      <!-- <div class="zj-header-logo"></div> -->
      <div class="zj-header-bg-p1"></div>
      <div class="zj-header-bg-p2"></div>
      <div class="zj-header-bg-p3"></div>
      <div class="zj-header-bg-p4"></div>
      <!-- <div class="zj-header-circle xuanzhun"></div> -->
      <!-- <div class="zj-header-bline-top"></div> -->
      <!-- <div class="zj-header-bline-bottom"></div> -->
    </div>
  </div>
</template>

<script>
import { validateAccessToken } from "../api/system/permission/login";
import { getToken } from '@/utils/auth';
// removeToken
export default {
  name: "ZjHeader",
  props: {
    height: String,
  },
  computed: {
    style() {
      return {
        height: this.height,
      };
    },
    title() {
      return this.theme.header.title.text
    },
    project() {
      return this.config.app.project
    }
  },
  methods:{
    toCommonLogin(){
      if(this.theme.header.title.webUrl){ 
        validateAccessToken(getToken())
        .then((res) => {
          if (res.code == 200) {
           if(res.data){
             window.open(this.theme.header.title.webUrl,"_self")
           }else {
            this.$message({type: "error", message: "accessToken已失效"});
            this.logout()
          }
          } 
        })
      }
    },
    logout() {
        location.href = "/";
        window.ZJApp.ZJUser.prototype.logout();
    },
  }
};
</script>
